// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"2fe1d385","128":"fcb5cc09","453":"4961eb71","479":"c138800e","629":"af7c2058","664":"c9a4d8e2","747":"29efc785"}[chunkId] + ".chunk.js";
};